import Typography from "@components/Typography";

import Message from "./Message";

import styles from "./Message.module.css";

const GenericError = () => {
  return (
    <Message data-testid="error-search-message">
      <Typography variant="h2" align="center">
        {L.ALERT_NO_MENTIONS_GENERIC_ERROR}
      </Typography>
      <Typography align="center" className={styles.dim}>
        {L.ALERT_NO_MENTIONS_GENERIC_ERROR_SUB}
      </Typography>
    </Message>
  );
};
export default GenericError;
